import { EntityTypeEnum } from '../../utilities/Enumerables';
import { PERMISSIONS } from '../../utilities/Permissions';

// Who sees the dashboard's Team section (Leaderboard, Staff Activity, staff breakdowns) and the
// header's Team Profile links: the role's View Team Stats permission (TEAM_STATS_ROLE_V1; Admin
// has it, Staff doesn't). Kept on its own so the header doesn't pull in the Leaderboard.
export const canSeeTeam = profile =>
  !!profile?.hasPermission?.(EntityTypeEnum.Settings, PERMISSIONS[EntityTypeEnum.Settings].VIEW_TEAM_STATS);
